<!-- 项目文件 -->
<template>
    <div class="bgfoot w100p hauto minw1200">
       <div class="w1200 mauto  pt20 pb20 ">
            <div class="cfff overhidden">
                <div class="disinblock floatl w20p">
                    <p class="fs18 cfff pt8 pb8">驾校服务</p>
                    <ul>
                        <router-link to="Smallprogram">
                            <li class=" c0c1 fs14  pt8 pb8">招生系统</li>
                        </router-link>
                        <router-link to="System">
                            <li class=" c0c1 fs14  pt8 pb8">培训系统</li>
                        </router-link>
                        <router-link to="Wemedia">
                            <li class=" c0c1 fs14  pt8 pb8">自媒体运营</li>
                        </router-link>
                        <router-link to="Meltmedia">
                            <li class=" c0c1 fs14  pt8 pb8">融媒体推广</li>
                        </router-link>
                    </ul>
                </div>
                <div class="disinblock floatl w20p">
                    <p class="fs18 cfff pt8 pb8">学车之家</p>
                    <ul>
                        
                        <li class=" c0c1 fs14  pt8 pb8 cursor"   @click="Toreschool()">驾校报名</li>
                    <li class=" c0c1 fs14  pt8 pb8 cursor"  @click="Toxuexi()" v-if="newYm==1"> 理论学习 </li>

                        <router-link  :to="{path:'Carhome?#xuexi',query:{studytype:'1'}}"  v-else>
                            <li class=" c0c1 fs14  pt8 pb8 cursor" >理论学习</li>
                        </router-link>
                        <router-link to="News">
                            <li class=" c0c1 fs14  pt8 pb8">学车资讯</li>
                        </router-link>
                        <router-link to="Video">
                            <li class=" c0c1 fs14  pt8 pb8">学车视频</li>
                        </router-link>
                        <router-link to="Guide" >
                            <li class=" c0c1 fs14  pt8 pb8">学车指南</li>
                        </router-link>
                    </ul> 
                </div>
                <div class="disinblock floatl w20p">
                    <p class="fs18 cfff pt8 pb8">合作伙伴</p>
                    <router-link to="Cooperation">
                        <li class=" c0c1 fs14  pt8 pb8"> 合作加盟 </li>
                    </router-link>
                    <router-link to="DriveSystem">
                        <li class=" c0c1 fs14  pt8 pb8"> 驾培系统 </li>
                    </router-link>
                    <router-link to="SmallMark">
                        <li class=" c0c1 fs14  pt8 pb8"> 小程序营销系统 </li>
                    </router-link>
                    <router-link to="addvalue">
                      <li class=" c0c1 fs14  pt8 pb8"> 增值业务 </li>
                    </router-link>
                    <router-link to="Flow">
                      <li class=" c0c1 fs14  pt8 pb8"> 流量经营 </li>
                    </router-link>
                    <router-link to="Businesscoop">
                      <li class=" c0c1 fs14  pt8 pb8"> 业务合作 </li>
                    </router-link>
                </div>
                <div class="disinblock floatl w20p">
                    <p class="fs18 cfff pt8 pb8">关于我们</p>
                    <ul>
                        <router-link to="Aboutwe">
                            <li class=" c0c1 fs14  pt8 pb8">公司简介</li>
                        </router-link>
                        <router-link to="AboutNews">
                            <li class=" c0c1 fs14  pt8 pb8">新闻动态</li>
                        </router-link>
                        <router-link to="Recruitment">
                            <li class=" c0c1 fs14  pt8 pb8">人才招聘</li>
                        </router-link>
                        <router-link to="Contact">
                            <li class=" c0c1 fs14  pt8 pb8">联系我们</li>
                        </router-link>
                    </ul>
                </div>
                <div class="disinblock floatl w20p">
                    <p class="pt10 pb8 textr">
                        <img class="w105 h105" src="../../public/img/img63.png" alt="">
                        <p  class="textr c0c1 fs14  ">关注微信公众号</p>
                    </p>
                </div>
            </div>
            <div class="textc pt57 pb0">
                <p class="textc c0c1 fs12 disinblock textr">
					江苏车里车外信息技术有限公司版权所有  
					<a target="_blank" class="fs12 c0c1 disinblock" href="https://beian.miit.gov.cn/">苏ICP备16034047号</a>
				</p>
            
                <div class="textc mt10 mb10   alit flexc ">
                    <a target="_blank" class="fs12 c0c1 disinblock"
                        href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32010502010365">
                        <span class="  alit flexc ">
                            <img src="../../public/img/beian.png" class="w20 h20" />
                            <span class="disinblock pl10 c0c1">苏公网安备 32010502010365号</span>
                        </span>
                    </a>
                    <span class="disinblock pl10   fs12 c0c1">
                        电信经营许可证编号：苏B2-20160598
                    </span>
                </div>
            </div>
       </div>
    </div>
</template>

<script>
    export default {
        props: ['newYm'],
        data() {
            return {

            };
        },
        methods: {
            Toxuexi() {
                document.querySelector("#xuexi").scrollIntoView(true)
            },
            Toreschool() {
                let that = this;

                let cityIDD = that.$store.state.cityIDX.name;

                this.$router.push({
                    path: "/Reschool",
                    query: {
                        cityid: cityIDD
                    }
                });
                // window.open(Toreschool.href, '_blank');
            },

        },
        created() {

        },
        mounted() {

        },
    }
</script>
<style scoped>
    .bgfoot {
        background-image: url('../../public/img/img64.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
    }
</style>